import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ImportDialogData } from '../../components/importar-general-dialog/import-dialog-data.token';

@Injectable({ providedIn: 'root' })
export class ImportDialogDataService {
  private readonly dataSubject = new BehaviorSubject<ImportDialogData | null>(null);
  data$ = this.dataSubject.asObservable();

  setData(data: ImportDialogData) {
    this.dataSubject.next(data);
  }

  clearData() {
    this.dataSubject.next(null);
  }

  getData(): ImportDialogData | null {
    return this.dataSubject.getValue();
  }
}
